import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { indexProjects, IndexProjectsAction } from 'src/actions/project/index/IndexProjects.actions';
import Project from 'src/entities/Project';
import MyProjectsListComponent from './MyProjectsList.component';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import * as getUserTypes from 'src/actions/user/get/Types';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';

interface StateProps {
  projects?: Project[];
  activeProfileId?: number;
  loggedUserData?: number;
}

interface DispatchProps {
  indexProjects: (key: string, founderId: number) => Promise<IndexProjectsAction>;
  getUser: (id: string) => Promise<GetUserAction>;
}

interface OwnProps {
  listKey: string;
}

interface Props extends StateProps, DispatchProps, OwnProps {
}

class MyProjectsListContainerUnconnected extends React.Component<Props> {

  static defaultProps = {
    listKey: 'myProjectsList'
  };

  constructor(props: Props) {
    super(props);
    if (this.props.activeProfileId) {
      this.props.indexProjects(this.props.listKey, this.props.activeProfileId);
    } else if (this.props.loggedUserData) {
      this.props.getUser(this.props.loggedUserData.toString()).then((response) => {
          if (response.type === getUserTypes.GET_USER_SUCCESS) {
            this.props.indexProjects(this.props.listKey, this.props.activeProfileId!);
          }
        }
      );
    }
  }

  public render(): React.ReactNode {
    return (
      this.props.projects ? (
          <MyProjectsListComponent
            projects={this.props.projects}
          />
        ) :
        <LoadingContainer/>
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    indexProjects: (key: string, founderId?: number): Promise<IndexProjectsAction> => {
      return dispatch(indexProjects(key, null, null, founderId));
    },
    getUser: (id: string): Promise<GetUserAction> => {
      return dispatch(getUser(id));
    }
  };
};

const mapStateToProps: (state: RootState, ownProps: OwnProps) => StateProps = (state: RootState, ownProps: OwnProps):
  StateProps => ({
  projects: state.indexProjects.projectsLists[ownProps.listKey],
  activeProfileId: state.getUser.activeProfile ? state.getUser.activeProfile.id : undefined,
  loggedUserData: state.authentication.loggedUserData || undefined,
});

const MyProjectsListContainer = connect(mapStateToProps, mapDispatchToProps)(MyProjectsListContainerUnconnected);

MyProjectsListContainer.defaultProps = MyProjectsListContainerUnconnected.defaultProps;

export default MyProjectsListContainer;


// WEBPACK FOOTER //
// ./src/modules/projects/my-projects/MyProjectsList.container.tsx